import { useLocale, useT } from '@/i18n/provider'
import { cn } from '@/lib/cn'

const LOCALES = [
  { value: 'en' as const, labelKey: 'locale.english' as const },
  { value: 'de' as const, labelKey: 'locale.german' as const },
]

export function LocaleToggle({ className }: { className?: string }) {
  const { locale, setLocale } = useLocale()
  const t = useT()

  return (
    <div
      className={cn('glass-sm inline-flex items-center gap-1 p-1 rounded-xl border border-white/10', className)}
      role="group"
      aria-label={t('common.localeLabel')}
    >
      {LOCALES.map(({ value, labelKey }) => (
        <button
          key={value}
          type="button"
          onClick={() => setLocale(value)}
          className={cn(
            'px-2.5 py-1.5 text-xs font-semibold rounded-lg transition-colors',
            locale === value
              ? 'bg-[var(--oc-accent)]/30 text-white border border-[var(--oc-accent)]/40'
              : 'text-white/60 hover:text-white/85 hover:bg-white/8',
          )}
          aria-pressed={locale === value}
        >
          {t(labelKey)}
        </button>
      ))}
    </div>
  )
}
